import * as React from 'react';
import CourtReporting939DataCore from '../CourtReporting/CourtReporting939DataCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { UserRoleEnum } from '../../redux/UserSlice';




const CourtReporting939CIA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <CourtReporting939DataCore userRole={isAdminUser ? UserRoleEnum.Admin : UserRoleEnum.EntityUser} dataSection={"CourtInnovations"} />
        </React.Fragment>
    );
}

export default CourtReporting939CIA;